(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["beneficios-producto"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-bp-action]');
    if (!el) return;
    var root = el.closest('.bp');
    var action = el.getAttribute('data-bp-action');
    var url = window.location.href.split('?')[0];
    if (action === 'whatsapp') {
      var num = root.getAttribute('data-wa');
      if (!num) return;
      e.preventDefault();
      var text = (root.getAttribute('data-wa-text') || '') + ' ' + root.getAttribute('data-product') + ' ' + url;
      window.open('https://wa.me/' + num + '?text=' + encodeURIComponent(text.trim()), '_blank', 'noopener');
    } else if (action === 'share') {
      e.preventDefault();
      var title = root.getAttribute('data-product');
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          var t = el.querySelector('.bp__title');
          if (!t || t.querySelector('.bp__ok')) return;
          var ok = document.createElement('span');
          ok.className = 'bp__ok'; ok.textContent = '¡Link copiado!';
          t.appendChild(ok);
          setTimeout(function () { ok.remove(); }, 2200);
        });
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
